function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState } from 'react';
var area = 48;
export var Burger = function Burger(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'left' : _ref$direction,
      _ref$distance = _ref.distance,
      distance = _ref$distance === void 0 ? 'md' : _ref$distance,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 0.4 : _ref$duration,
      _ref$easing = _ref.easing,
      easing = _ref$easing === void 0 ? 'cubic-bezier(0, 0, 0, 1)' : _ref$easing,
      _ref$hideOutline = _ref.hideOutline,
      hideOutline = _ref$hideOutline === void 0 ? true : _ref$hideOutline,
      label = _ref.label,
      _ref$lines = _ref.lines,
      lines = _ref$lines === void 0 ? 3 : _ref$lines,
      onToggle = _ref.onToggle,
      render = _ref.render,
      _ref$rounded = _ref.rounded,
      rounded = _ref$rounded === void 0 ? false : _ref$rounded,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 32 : _ref$size,
      toggle = _ref.toggle,
      toggled = _ref.toggled;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      toggledInternal = _useState2[0],
      toggleInternal = _useState2[1];

  var width = Math.max(12, Math.min(area, size));
  var room = Math.round((area - width) / 2);
  var barHeightRaw = width / 12;
  var barHeight = Math.round(barHeightRaw);
  var space = distance === 'lg' ? 0.25 : distance === 'sm' ? 0.75 : 0.5;
  var marginRaw = width / (lines * (space + (lines === 3 ? 1 : 1.25)));
  var margin = Math.round(marginRaw);
  var height = barHeight * lines + margin * (lines - 1);
  var topOffset = Math.round((area - height) / 2);
  var translate = lines === 3 ? distance === 'lg' ? 4.0425 : distance === 'sm' ? 5.1625 : 4.6325 : distance === 'lg' ? 6.7875 : distance === 'sm' ? 8.4875 : 7.6675;
  var deviation = (barHeightRaw - barHeight + (marginRaw - margin)) / (lines === 3 ? 1 : 2);
  var move = parseFloat((width / translate - deviation / (4 / 3)).toFixed(2));
  var time = Math.max(0, duration);
  var burgerStyles = {
    cursor: 'pointer',
    height: "".concat(area, "px"),
    position: 'relative',
    transition: "".concat(time, "s ").concat(easing),
    userSelect: 'none',
    width: "".concat(area, "px")
  };
  var barStyles = {
    background: color,
    height: "".concat(barHeight, "px"),
    left: "".concat(room, "px"),
    position: 'absolute',
    width: "".concat(width, "px")
  };

  if (hideOutline) {
    burgerStyles['outline'] = 'none';
  }

  if (rounded) {
    barStyles['borderRadius'] = '9em';
  }

  var toggleFunction = toggle ? toggle : toggleInternal;
  var isToggled = toggled ? toggled : toggledInternal;

  var handler = function handler() {
    toggleFunction(!isToggled);

    if (typeof onToggle === 'function') {
      onToggle(!isToggled);
    }
  };

  return render({
    barHeight: barHeight,
    barStyles: barStyles,
    burgerStyles: burgerStyles,
    easing: easing,
    handler: handler,
    isLeft: direction === 'left',
    isToggled: isToggled,
    label: label,
    margin: margin,
    move: move,
    time: time,
    topOffset: topOffset
  });
};